import { useRouterState } from '@tanstack/react-router'
import { useEffect, useState } from 'react'

export function isElementContentOverflow(element: HTMLElement): boolean {
	const isOverflow =
		// 其实这个地方只需要判断 scrollHeight 和 clientHeight 就可以了，当 scrollHeight 大于 clientHeight 时，就说明元素的内容已经溢出了。
		// 但有且仅当在 Safari 缩放比率为 115% 和 125% 时，scrollHeight 和 clientHeight 的差值会出现 1px 的误差，所以这里加上了 1px 的误差。其他的浏览器任何缩放比率都没有这个问题。
		element.scrollHeight - element.clientHeight > 1 || element.scrollWidth - element.clientWidth > 1
	return isOverflow
}

export function scrollToTop(scrollElement: Element = document.documentElement): boolean {
	const isScrolled = scrollElement.scrollTop !== 0
	let isScrollReset = false

	if (isScrolled) {
		scrollElement.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
		isScrollReset = true
	} else {
		isScrollReset = false
	}

	return isScrollReset
}

export const SCROLL_POSITION_CACHE: Record<string, number> = {}
export function cacheScrollPosition(y: number) {
	SCROLL_POSITION_CACHE[window.location.pathname] = y
}

export function useScrollPostionRestoration() {
	const {
		isLoading,
		isTransitioning,
		location: { pathname },
	} = useRouterState()
	const [isRestored, setIsRestored] = useState<boolean>(false)

	useEffect(() => {
		if (isLoading || isTransitioning) {
			return
		}

		const top = SCROLL_POSITION_CACHE[pathname] ?? 0
		window.scrollTo({ top, behavior: 'instant' })
		setIsRestored(true)
	}, [isLoading, isTransitioning, pathname])

	return isRestored
}
